import { render } from "./popup-recharge.vue?vue&type=template&id=5e4edb73&scoped=true&ts=true"
import script from "./popup-recharge.vue?vue&type=script&lang=ts"
export * from "./popup-recharge.vue?vue&type=script&lang=ts"

import "./popup-recharge.vue?vue&type=style&index=0&id=5e4edb73&scoped=true&lang=stylus"

import exportComponent from "E:\\code\\pc-customer-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e4edb73"]])

export default __exports__